import { Injectable }                                           from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable }                                           from 'rxjs';
import { IframeService }                                        from '../../core/iframe.service';
import { environment }                                          from '../../../environments/environment';

@Injectable()
export class IframeStatusInterceptor implements HttpInterceptor {
  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (req.url.startsWith(environment.apiBaseUrl)) {
      const runsInIframe = IframeService.runsInIframe();
      const params = req.params.set('runsInIframe', runsInIframe);
      const clonedReq = req.clone({params});
      return next.handle(clonedReq);
    }
    return next.handle(req);
  }
}
